__turbopack_context__.v({
  "fadeUp": "login-module__7V2Yca__fadeUp",
  "panel": "login-module__7V2Yca__panel",
  "panelGrid": "login-module__7V2Yca__panelGrid",
});
